import { observer } from "mobx-react";
import _ from "lodash";
import { Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useStores } from "../../stores/root-store";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ProductOfferForm from "./product-offer-form";
import ProductOfferListing from "./product-offer-listing";

const ManageProductOffers = observer(() => {
  const { productOfferStore } = useStores();
  const { editOffer, setEditOffer } = productOfferStore;
  const [showProductForm, setShowProductForm] = useState(false);

  const handleProductFormClose = (show: boolean) => {
    setShowProductForm(show);
    if (!show) setEditOffer(null, false);
  };

  useEffect(() => {
    setShowProductForm(editOffer != null);
  }, [editOffer]);

  return (
    <div className="container mt-3 pb-3">
      <div className="row mb-3">
        <h5 className="mb-0 text-start">
          Product Offers
          <Button
            onClick={() => setShowProductForm(true)}
            className="btn-default float-end"
          >
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            New Offer
          </Button>
        </h5>
      </div>
      <ProductOfferListing />
      {showProductForm && (
        <ProductOfferForm
          show={showProductForm}
          setShowModal={handleProductFormClose}
        />
      )}
    </div>
  );
});

export default ManageProductOffers;
